import { User } from "oidc-client-ts";

export let KEYCLOAK_CONFIG = {
  clientId: "e-contract",
  url: "https://auth.cz.dhl.com/auth/realms/dhl",
};

export const getUser = () => {
  const key = `oidc.user:${KEYCLOAK_CONFIG.url}:${KEYCLOAK_CONFIG.clientId}`;
  const oidcStorage = sessionStorage.getItem(key) || localStorage.getItem(key);
  return oidcStorage ? User.fromStorageString(oidcStorage) : null;
};
